import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  progress: {
    margin: theme.spacing(2)
  },
  centered: {
    display: 'flex',
    justifyContent: 'center',
    height: '100vh',
    alignItems: 'center'
  }
}));

export default function Loading() {
  const classes = useStyles();
  return (
    <div className={classes.centered}>
      <CircularProgress className={classes.progress} />
    </div>
  );
}
